module.exports = __webpack_public_path__ + "static/Q5Answer_Augustus_peanut_wishmastree-1c21c3bb6b774c8d51e27dc7ccb0043b.jpg";